import { request as openRequest } from './open';

export function request(data) {
    return {
        type: 'CUSTOMERS_CREATE_REQUEST',
        data
    };
}

export function error(errors, debug) {
    return {
        type: 'CUSTOMERS_CREATE_ERROR',
        errors,
        debug
    };
}

export function finish(customer) {
    const firstName = customer.firstName.hasOwnProperty("value") ? customer.firstName.value : customer.firstName;
    const surname = customer.surname.hasOwnProperty("value") ? customer.surname.value : customer.surname;

    return (dispatch) => {
        dispatch({
            type: 'CUSTOMERS_CREATE_FINISH',
            customer
        });

        dispatch(
            openRequest(customer.id, `${firstName } ${ surname}`)
        );
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_CREATE_CLEAR'
    };
}
